import React from "react";
import { useArbeitszeitStore } from "../../../store/zustandArbeitszeitenStore";
import IWConfirmationModal from "../../uiElemente/IWConfirmationModal/IWConfirmationModal";

type ConfirmationModalWrapperProps = {
  handleCancelConfirmationModal: () => void;
  handleSubmitConfirmationModal: () => void;
};

function ConfirmationModalWrapper(props: ConfirmationModalWrapperProps) {
  const isModalConfirmationVisible = useArbeitszeitStore(state => state.isModalConfirmationVisible);

  return (
    <IWConfirmationModal
      displayModal={isModalConfirmationVisible}
      closeAction={props.handleCancelConfirmationModal}
      okAction={props.handleSubmitConfirmationModal}
    />
  );
}

export default React.memo(ConfirmationModalWrapper);